'use strict';

require('core-js/modules/es6.array.find');

require('core-js/modules/es6.array.is-array');

require('core-js/modules/es6.array.for-each');

require('core-js/modules/es6.string.starts-with');

require('core-js/modules/es6.map');

require('core-js/modules/es6.promise');

require('fetch-polyfill');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initializers = require('./app/initializers');

var _initializers2 = _interopRequireDefault(_initializers);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

var _localize = require('linksoft/core/localize');

require('./app/scripts.js');

require('./app/editor.js');

require('./app/complaints/actions');

var _tableTemplates = require('./app/table-templates');

var _tableTemplates2 = _interopRequireDefault(_tableTemplates);

require('./app/dt-control-buttons');

require('./app/dropdown');

require('./app/user');

require('./app/isNewsletterFilter');

require('./app/isCustomFilter');

require('./app/datatables');

var _store = require('./app/store');

var _store2 = _interopRequireDefault(_store);

var _linksoft = require('linksoft');

var _linksoft2 = _interopRequireDefault(_linksoft);

var _linksoftAlbatros = require('linksoft-albatros');

var _reducer = require('./app/complaints/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_linksoft2.default.reducers.add('complaints', _reducer2.default); // This is entry point for building single output 'main.js'

// polyfills


(0, _jquery2.default)(document).on('loaded.bs.modal', function (e) {
    abp.log.debug('modal content loaded');
    abp.log.debug(e.target);
    _initialize2.default.trigger(e.target);
});
// register all required initializers
_initialize2.default.registerAll(_initializers2.default);

// trigger first initialization.
(0, _jquery2.default)(function () {
    // create app state store
    _linksoft2.default.store.set((0, _store2.default)());
    _linksoftAlbatros.settings.initFromHiddenField('settings');

    (0, _tableTemplates2.default)();

    (0, _localize.loadLocale)().then(function () {
        _initialize2.default.trigger();
    });
    (0, _jquery2.default)(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app.js
// module id = 0
// module chunks = 0